import { render } from "./AllDoctors.vue?vue&type=template&id=8b0223fc&scoped=true"
import script from "./AllDoctors.vue?vue&type=script&lang=js"
export * from "./AllDoctors.vue?vue&type=script&lang=js"

import "./AllDoctors.vue?vue&type=style&index=0&id=8b0223fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0223fc"]])

export default __exports__